export type VolumePage = {
  src: string
  label: string
  caption: string
  alt: string
}

/** Real interior pages of Volume 5 "Intermediate & Combinations" (1080×1920 portrait). */
export const volumePages: VolumePage[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/2UCx4BZgvzeJB1goUGWADV/carrusel-01-pag17.png',
    label: 'Silks — Intermediate Class 3',
    caption: 'Silks: every wrap labeled, step by step',
    alt: 'Silks Intermediate Class 3 page: Single-Star and Slack-Drop Prep, with five labeled wraps, pre-flight check, timings, cues and easier/harder options',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/qjowEF5jhUYWZDZurUD1LE/carrusel-02-pag22.png',
    label: 'Hoop — Intermediate Class 4',
    caption: 'Hoop: a full intermediate sequence in one view',
    alt: 'Hoop Intermediate Class 4 page: a six-step sequence from pullover to dismount, with cues, easier/harder options and a 75-minute timeline',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/vWRHJexWd3g63enXuhdX9o/carrusel-03-pag25.png',
    label: 'Trapeze — Intermediate Class 3',
    caption: 'Trapeze: beats into shapes, with the clear zone marked',
    alt: 'Trapeze Intermediate Class 3 page: Beats into Shapes, showing the swing arc, clear zone, pre-flight notes, clock-grid timings and cues',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/jxeDofNjY3yPKwywYzPeWb/carrusel-04-pag30.png',
    label: '8 Intermediate Combinations',
    caption: '8 combinations to drop into any class',
    alt: 'Page of 8 intermediate combinations across silks, hoop and trapeze, each tagged as level change, rotation or plane',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/c8XSNKYqqjkennRadWdyKB/carrusel-05-pag36.png',
    label: "Transitions: Do's and Don'ts",
    caption: "Do's and don'ts for every transition",
    alt: "Transitions Do's and Don'ts page comparing four common mistakes with four correct approaches, plus a teaching tip",
  },
]
